import React, { useState, useContext } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import { DialogContext } from '../context/DialogContext.js'
import { useMutation, gql } from '@apollo/client'
import languages from '../languages.js'
import { Box } from '@mui/material'
import TagsInput from './dialoginputs/TagsInput.js'
import UserContext from '../context/UserContext.js'
import UsersInput from './dialoginputs/UsersInput.js'

// Define the new GraphQL mutation
const TRANSLATE_AND_SAVE_ALL_LANGUAGES_MUTATION = gql`
  mutation TranslateAndSaveAllLanguages($sourceText: String!, $sourceLang: String!, $username: String!, $tags: [String]!, $sharedWith: [String]!) {
    translateAndSaveAllLanguages(sourceText: $sourceText, sourceLang: $sourceLang, username: $username, tags: $tags, sharedWith: $sharedWith) {
      message
    }
  }
`

function AddSentenceAllTranslationsDialog() {
  const { dialogStates, closeDialog } = useContext(DialogContext)
  const [sourceLanguage, setSourceLanguage] = useState(Object.keys(languages)[0]) // Default to first language
  const [sourceSentence, setSourceSentence] = useState('')
  const [users, setUsers] = useState([]) // Default to empty array, adjust as needed
  const [tags, setTags] = useState([])
  const { username } = useContext(UserContext)

  // Use the new mutation
  const [translateAndSaveAllLanguages, { loading: processLoading }] = useMutation(TRANSLATE_AND_SAVE_ALL_LANGUAGES_MUTATION)

  const handleClose = () => {
    closeDialog('dialogAddSentenceAllTranslations')
  }

  const handleSourceLanguageChange = (event) => {
    setSourceLanguage(event.target.value)
  }

  const handleSourceSentenceChange = (event) => {
    setSourceSentence(event.target.value)
  }

  const handleSave = async () => {
    try {
      const { data } = await translateAndSaveAllLanguages({
        variables: {
          sourceText: sourceSentence,
          sourceLang: sourceLanguage,
          username,
          tags,
          sharedWith: users
        }
      })
      alert(data.translateAndSaveAllLanguages.message) // Show confirmation
      handleClose()
      setSourceSentence('') // Reset input
    } catch (error) {
      console.error('Error starting translation process:', error)
      alert('Failed to start translation process.')
    }
  }

  return (
    <Dialog open={dialogStates['dialogAddSentenceAllTranslations']} onClose={handleClose}>
      <DialogTitle>Add a new sentence to all languages</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="sourceSentence"
          label="Source Sentence"
          type="text"
          fullWidth
          value={sourceSentence}
          onChange={handleSourceSentenceChange}
        />
        <Select labelId="source-language-label" id="sourceLanguage" value={sourceLanguage} onChange={handleSourceLanguageChange} fullWidth>
          {Object.entries(languages).map(([key, value]) => (
            <MenuItem key={key} value={key}>
              {value}
            </MenuItem>
          ))}
        </Select>
        <Box mt={2}>
          <TagsInput selectedTags={setTags} fullWidth variant="outlined" id="tags" name="tags" placeholder="Add Tags" label="Tags" />
        </Box>
        <Box mt={2}>
          <UsersInput
            selectedUsers={setUsers}
            users={users}
            fullWidth
            variant="outlined"
            id="users"
            name="users"
            placeholder="Type username"
            label="Share with"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSave} disabled={processLoading || !sourceSentence}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddSentenceAllTranslationsDialog
